export default __webpack_public_path__ + "assets/dff8bba987babf20eb90bf10d429dd4c.png";